"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialBalanceReportTypeIterable = exports.TapeBuilderNodePositionSchema = exports.BusServicingCycleCertificateStatuses = exports.BusServicingCycleApprovalStatuses = exports.BusServicingCycleStatuses = exports.CreditFacilityContingentLiabilityProducts = exports.ReceivableResponseTapePreviewReportTypeIterable = exports.LenderShareReportTypeIterable = exports.InvoiceReportTypeIterable = exports.BackupServicingReportTypeIterable = exports.FundingRequestReportTypeIterable = exports.CreditFacilityReportTypeIterable = exports.BorrowingBaseServicerReportTypeIterable = exports.BatchSettlementReportTypeIterable = exports.AssignedLoanTapeReportTypeIterable = exports.ComplianceReportCfTypeIterable = exports.MetricKey = exports.MetricKeyIterable = exports.ManualBankAccountReportSource = exports.ManualBankAccountReportSourceIterable = exports.WEBHOOK_EVENT_TYPES = exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = exports.OrganizationWireSchema = exports.OrganizationSchema = exports.BankAccountWithInstitutionSchema = exports.BankInstitutionKeySchema = exports.DocumentTypeIterable = exports.FacilityTypeIterable = exports.TellerEnrollmentStatus = exports.TellerEnrollmentStatusIterable = exports.ComplianceStatusSchema = exports.ComplianceStatusIterable = exports.UserWireSchema = exports.UserSchema = exports.ArtifactWithSlugsSchema = exports.ArtifactInstance = exports.ArtifactDependencyRecordSchema = exports.ArtifactTypeIterable = exports.UserInputTypeSchema = exports.GeneratedArtifactTypeIterable = exports.TableName = exports.ALL_TABLES = void 0;
const BankTypes = __importStar(require("./Bank"));
const OrganizationTypes = __importStar(require("./Shared/SharedOrganization"));
const zod_1 = require("zod");
// The table-name source of truth (`ALL_TABLES`), the `DbTables` type, and the `TableName`
// constants live in the dependency-free `./TableNames` leaf module and are re-exported here for
// backwards compatibility. Keeping them in a leaf module avoids forcing this heavy file's large
// import graph to be evaluated at runtime just to reference a table name, and prevents any
// circular dependency.
const TableNames_1 = require("./TableNames");
Object.defineProperty(exports, "ALL_TABLES", { enumerable: true, get: function () { return TableNames_1.ALL_TABLES; } });
Object.defineProperty(exports, "TableName", { enumerable: true, get: function () { return TableNames_1.TableName; } });
exports.GeneratedArtifactTypeIterable = [
    'generatedCovenantLoanTape',
    'generatedLoanTape',
    'generatedCashBalanceFeed',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'generatedFinancialData',
];
exports.UserInputTypeSchema = zod_1.z.enum([
    'assignement',
    'verificationApproval',
    'dataLakeTableHydration',
    'cashContext',
    // BUS: human accept/reject of the reconcile result — the certificate gate.
    // Pauses the pipeline after `reconciledBusTape` until the portal decision
    // resumes it (see synthetic/busReconcileApprovalUserInput.ts).
    'busReconcileApproval',
]);
exports.ArtifactTypeIterable = [
    ...exports.GeneratedArtifactTypeIterable,
    'userInputNeeded', // this task indicates that the pipeline needs input from the user
    'rawLoanTape',
    'rawCashBalanceFeed',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'rawZipTape', // this special raw artifact type is handled by the ingest-organizer-lambda
    'configTape',
    'rawReceivableDocumentation',
    'intermediateTape',
    'internalRepaymentTape',
    'cashResponseTape',
    'cashBalancesFeedContext',
    'masterLoanTape',
    'manualBankAccountReport',
    'assignedLoanTape',
    'assignedRepaymentTape',
    'receivableResponseTapePreview',
    'reconciledBusTape',
    'busCertificate',
    'receivableResponseTape',
    'borrowingBaseReport',
    'directInsertBorrowingBaseReport',
    'directInsertPortfolioCovenant',
    'directInsertPortfolioCovenants',
    'directInsertFinancialCovenants',
    'finStatement',
    'receivableInvoice',
    'fundingVerificationReport',
    'fundingApprovalReport',
    'fundingRequest',
    'receivableDocumentationVerificationReport',
    'forwardedTape',
    'valleyBankIngest',
    'valleyBankSlsIngest',
    'valleyBankSlsCommitment',
    'orgProvidedInput',
    'orgProvidedInputs',
    'uploadToDatalake',
    'waitForDataLakeTable', // task that waits for a data lake table to be ready
    'dataLakeTape', // task that generates a csv file from a data lake query
    'limitedPartnersTape',
];
// unique constraint on outputArtifactId + inputArtifactId
exports.ArtifactDependencyRecordSchema = zod_1.z.object({
    outputArtifactId: zod_1.z.string(), // data tape to create from a list of inputs (dependencies)
    inputArtifactId: zod_1.z.string(), // dependency (an input) to create the output
});
/** Uniqueness constraint exists on the table. */
// Re-export ArtifactInstance as module
const ArtifactInstanceModule = __importStar(require("./ArtifactInstance"));
exports.ArtifactInstance = ArtifactInstanceModule;
// Zod schema for ArtifactWithSlugs
exports.ArtifactWithSlugsSchema = zod_1.z.object({
    // All fields from Artifact except creditFacilityId and loanProductId
    id: zod_1.z.string(),
    artifactSlug: zod_1.z.string(),
    artifactDocumentId: zod_1.z.string(),
    type: zod_1.z.string(), // ArtifactType, but as string for schema
    externalFilename: zod_1.z.string().nullable(),
    configuration: zod_1.z.object({}),
    // Add the slug fields
    creditFacilitySlug: zod_1.z.string().nullable(),
    loanProductSlug: zod_1.z.string().nullable(),
});
// Users
exports.UserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    created_at: zod_1.z.date(),
    updated_at: zod_1.z.date(),
    isActive: zod_1.z.boolean(),
    email: zod_1.z.string(),
    password: zod_1.z.string().optional(),
    userType: OrganizationTypes.UserTypeSchema,
    // NOTE:
    // organizationId will likely go away in the future, and we will manage
    // N:M relationship between user<>organizations
    organizationId: zod_1.z.string(),
    roleType: OrganizationTypes.UserRoleTypeSchema,
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    // this eventually can become required, but for safety we will make optional in all types for now
    // our codebase does not explicitly need to be aware for this for now [with exception of any strict runtime type checks]
    isAiAgentEnabled: zod_1.z.boolean().optional(), // can this is user use the n8n service, used by n8n for authN
});
// Wire schema for JSON schema generation (uses string datetime instead of Date)
exports.UserWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    isActive: zod_1.z.boolean(),
    email: zod_1.z.string(),
    password: zod_1.z.string().optional(),
    userType: OrganizationTypes.UserTypeSchema,
    organizationId: zod_1.z.string(),
    roleType: OrganizationTypes.UserRoleTypeSchema,
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    isAiAgentEnabled: zod_1.z.boolean().optional(),
});
// ============================================================================
// COMPLIANCE STATUS SCHEMA
// ============================================================================
exports.ComplianceStatusIterable = [
    'COMPLIANT',
    'LIMIT_WARNING',
    'LIMIT_REACHED',
    'WAIVED',
];
exports.ComplianceStatusSchema = zod_1.z.enum(exports.ComplianceStatusIterable);
exports.TellerEnrollmentStatusIterable = [
    'connected',
    'disconnected',
    'accountLocked',
    'inactive',
    'credentialsInvalid',
    'captchaRequired',
    'mfaRequired',
    'webLoginRequired',
];
exports.TellerEnrollmentStatus = {
    Connected: 'connected', // the default status, means the connection is live and healthy
    Disconnected: 'disconnected',
    AccountLocked: 'accountLocked',
    Inactive: 'inactive',
    CredentialsInvalid: 'credentialsInvalid',
    CaptchaRequired: 'captchaRequired',
    MfaRequired: 'mfaRequired',
    WebLoginRequired: 'webLoginRequired', // the current enrollment (connection) status
};
exports.FacilityTypeIterable = [
    'creditFacility',
    'forwardFlow',
    'securitization',
    'capitalCallLine',
    'backupServicing',
];
/******************** CreditFacility Document Types ********************/
exports.DocumentTypeIterable = [
    'creditAgreement',
    'participationAgreement',
];
const DocumentStatusIterable = ['latestPublished', 'published'];
exports.BankInstitutionKeySchema = zod_1.z.string();
const BankAccountSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    implementationId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    plaidAccountId: zod_1.z.optional(zod_1.z.string().nullable()),
    tellerAccountId: zod_1.z.optional(zod_1.z.string().nullable()),
    bankInstitutionId: zod_1.z.string(),
    routingNumber: zod_1.z.string(),
    accountNumber: zod_1.z.string(),
    currencyCode: BankTypes.CurrencyCodeSchema,
});
const ImplementationBankAccountSchema = BankAccountSchema.extend({
    implementationId: zod_1.z.string(),
    // @implementation: support API integrations with implementation-owned bank accounts.
    // This will require split auth - implementation owner owns the bank account, but the
    // real life bank account owner owns the API integration.
    plaidAccountId: zod_1.z.null(),
    tellerAccountId: zod_1.z.null(),
});
exports.BankAccountWithInstitutionSchema = BankAccountSchema.extend({
    institutionName: zod_1.z.string(),
    bankInstitutionKey: exports.BankInstitutionKeySchema,
});
exports.OrganizationSchema = OrganizationTypes.BaseOrganizationSchema.extend({
    // In the DB, these are nullable to allow temporarily breaking a circular FK reference between
    // orgs and groups. In regular operation, this should never be null.
    ownerGroupId: zod_1.z.string(),
    allUsersGroupId: zod_1.z.string(),
    type: OrganizationTypes.OrganizationTypeSchema,
    industry: zod_1.z.string().optional(),
    created_at: zod_1.z.date(),
    updated_at: zod_1.z.date(),
});
// Wire schema for JSON schema generation (uses string datetime instead of Date)
exports.OrganizationWireSchema = OrganizationTypes.BaseOrganizationSchema.extend({
    ownerGroupId: zod_1.z.string(),
    allUsersGroupId: zod_1.z.string(),
    type: OrganizationTypes.OrganizationTypeSchema,
    industry: zod_1.z.string().optional(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
});
exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = ['assignment.assign'];
exports.WEBHOOK_EVENT_TYPES = [
    ...exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES,
    'fundingRequest.approved',
    'borrowingBaseReport.generated',
];
exports.ManualBankAccountReportSourceIterable = [
    'adminDashboard',
    'borrowerDashboard',
    'borrowerS3Upload',
];
exports.ManualBankAccountReportSource = {
    AdminDashboard: 'adminDashboard',
    BorrowerDashboard: 'borrowerDashboard',
    BorrowerS3Upload: 'borrowerS3Upload',
};
exports.MetricKeyIterable = ['collateralCovenantLtv'];
exports.MetricKey = {
    collateralCovenantLtv: 'collateralCovenantLtv',
};
// At the moment, this would generally align with "ReportConfigTypeIterable" in
// "CreditAgreement.DomainEntity", potentially being a subset of it.
exports.ComplianceReportCfTypeIterable = [
    'monthlyServicerReport',
];
exports.AssignedLoanTapeReportTypeIterable = [
    'receivablesSaleAgreement',
];
exports.BatchSettlementReportTypeIterable = ['batchSettlement'];
exports.BorrowingBaseServicerReportTypeIterable = [
    'borrowingBaseServicerReport',
];
exports.CreditFacilityReportTypeIterable = ['assetVerification'];
exports.FundingRequestReportTypeIterable = [
    'borrowingBaseCertificate',
    'fundingRequestServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'releaseNotice',
];
exports.BackupServicingReportTypeIterable = [
    'backupServicingCertificate',
];
exports.InvoiceReportTypeIterable = [
    'invoice',
    'disbursementNotice',
    'paymentInKindNotice',
];
exports.LenderShareReportTypeIterable = ['fundingNotice'];
exports.ReceivableResponseTapePreviewReportTypeIterable = [
    'receivableResponseTapePreviewServicerReport',
];
const threadDomains = [
    'fundingRequest.request',
    'valleyBank.loanAccountNumber',
    'deliverables.container',
    'limitedPartner',
    'invoice',
];
exports.CreditFacilityContingentLiabilityProducts = [
    'letterOfCredit',
];
// *****************************************************
//              BACKUP SERVICING (BUS)
// *****************************************************
/**
 * Overall state of one Backup Servicing monthly compliance cycle. Advances:
 * awaiting_tape → reconciling → awaiting_approval → certifying → complete,
 * with rejected / blocked as terminal-ish off-ramps. See
 * docs/bus/reference/msr-reconciliation.md §9.
 */
exports.BusServicingCycleStatuses = [
    'awaiting_tape',
    'reconciling',
    'awaiting_approval',
    'certifying',
    'complete',
    'rejected',
    'blocked',
];
/** Human accept/reject decision on the reconcile result (the certificate gate). */
exports.BusServicingCycleApprovalStatuses = [
    'pending',
    'accepted',
    'rejected',
];
/** Certificate document lifecycle. `null` until the accept branch starts it. */
exports.BusServicingCycleCertificateStatuses = [
    'blocked',
    'draft',
    'issued',
    'signed',
];
exports.TapeBuilderNodePositionSchema = zod_1.z.object({
    artifactIdentifier: zod_1.z.string(),
    x: zod_1.z.number(),
    y: zod_1.z.number(),
});
exports.TrialBalanceReportTypeIterable = [
    'facilityTrialBalance',
    'loanTrialBalance',
];
//# sourceMappingURL=DbTables.js.map